import { SearchFieldV2 as SearchField, FormFieldV2 as FormField } from '@/components/custom/erp';
import { customerSearchColumns, groupColumns, regionColumns } from '@/constants/search-columns';
import { QUERY_KEYS } from '@/constants/query-keys';
import { Label } from '@/components/ui/label';

interface DetailsTabProps {
  searchFieldStates: BanHangRecord;
}

const DetailsTab: React.FC<DetailsTabProps> = ({ searchFieldStates }) => {
  return (
    <div className='w-[800px] min-w-[800px] space-y-2 p-4'>
      <div className='flex flex-col space-y-1'>
        {/* Mã khách hàng */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Mã khách hàng:</Label>
          <div className='flex-1'>
            <SearchField
              type='text'
              searchEndpoint={`/${QUERY_KEYS.KHACH_HANG}`}
              searchColumns={customerSearchColumns}
              columnDisplay='customer_code'
              displayRelatedField='customer_name'
              dialogTitle='Danh mục khách hàng'
              onRowSelection={searchFieldStates.setCustomer}
            />
          </div>
        </div>
        <div className='flex items-center'>
          <FormField label='Tính số dư' name='so_du' className='w-[400px]' labelClassName='w-40' type='checkbox' />
        </div>

        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Nhóm khách hàng:</Label>
          <div className='flex-1'>
            <div className='flex gap-1'>
              <SearchField
                type='text'
                searchEndpoint={`/${QUERY_KEYS.NHOM}?loai_nhom=NCC1`}
                searchColumns={groupColumns}
                columnDisplay='ma_nhom'
                dialogTitle='Danh mục nhóm khách hàng 1'
                onRowSelection={searchFieldStates.setCustomerGroup1}
                className='w-48'
              />
              <SearchField
                type='text'
                searchEndpoint={`/${QUERY_KEYS.NHOM}?loai_nhom=NCC2`}
                searchColumns={groupColumns}
                columnDisplay='ma_nhom'
                dialogTitle='Danh mục nhóm khách hàng 2'
                onRowSelection={searchFieldStates.setCustomerGroup2}
                className='w-48 pl-2'
              />
              <SearchField
                type='text'
                searchEndpoint={`/${QUERY_KEYS.NHOM}?loai_nhom=NCC3`}
                searchColumns={groupColumns}
                columnDisplay='ma_nhom'
                dialogTitle='Danh mục nhóm khách hàng 3'
                onRowSelection={searchFieldStates.setCustomerGroup3}
                className='w-48 pl-2'
              />
            </div>
          </div>
        </div>
        <div className='mb-4'>
          <div className='flex items-center'>
            <Label className='w-40 min-w-40'>Khu vực:</Label>
            <SearchField
              type='text'
              searchEndpoint={`/${QUERY_KEYS.KHU_VUC}`}
              searchColumns={regionColumns}
              columnDisplay='rg_code'
              displayRelatedField='rgname'
              dialogTitle='Danh mục khu vực'
              onRowSelection={searchFieldStates.setRegion}
            />
          </div>
        </div>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Người lập:</Label>
          <div className='flex-1'>
            <FormField name='nguoi_lap' type='text' className='w-96' />
          </div>
        </div>
        <div className='flex items-center'>
          <FormField
            name='mau_bc'
            label='Mẫu báo cáo'
            labelClassName='w-40'
            type='select'
            options={[
              { value: 20, label: 'Mẫu tiền chuẩn' },
              { value: 21, label: 'Mẫu ngoại tệ' }
            ]}
            className='w-[400px]'
          />
        </div>
      </div>
    </div>
  );
};

export default DetailsTab;
